module.exports = __webpack_public_path__ + "media/images/nutri_ads/restilen_750x90_3-0f7aa163739cb04f2185daabc5c99402.jpg";